import React from "react";
// material ui
import { Grid, IconButton, Typography } from "@mui/material";

function gridFunction(data, iconButton, icon, fontsize, variant, textColor, alignItem, type) {
  function CheckIcon(icon) {
    if (icon) {
      return icon;
    }
    return null;
  }

  return (
    <Grid
      container
      direction="row"
      sx={{
        alignItems: "center",
        justifyContent: alignItem || null
      }}>
      {type != "textOnly" ? (
        iconButton == true ? (
          <IconButton
            sx={{
              borderRadius: "11px",
            }}
            size="small"
          >
            {CheckIcon(icon)}
          </IconButton>
        ) : (
          CheckIcon(icon)
        )
      ) : null}
      <Typography
        variant={variant || "paragraph"}
        style={{
          color: textColor || "#43425D",
          marginLeft: "8px",
          // fontWeight: "500",
          fontSize: fontsize || "11px",
        }}
      >
        {data}
      </Typography>
    </Grid>
  );
}

function EmailWithIcon(props) {
  const { data, iconButton, icon, fontsize, variant, textColor, alignItem, type } = props;

  return <>{data ? gridFunction(data, iconButton, icon, fontsize, variant, textColor, alignItem, type) : null}</>;
}

export default EmailWithIcon;
